import type { ReportDef } from './reportRegistry';

interface ReportSelectorProps {
  reports: ReportDef[];
  value: string;
  onChange: (id: string) => void;
}

/**
 * Combobox that picks which report is shown within the current tab.
 * The option list is supplied by the page (filtered to its tab).
 */
export function ReportSelector({ reports, value, onChange }: ReportSelectorProps) {
  return (
    <div className="flex items-center gap-2">
      <label htmlFor="report-selector" className="text-sm font-medium text-gray-600">
        Report
      </label>
      <select
        id="report-selector"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="min-w-[16rem] rounded-md border-gray-300 shadow-sm focus:border-primary-500 focus:ring-primary-500"
      >
        {reports.map((r) => (
          <option key={r.id} value={r.id}>
            {r.label}
            {r.ready ? '' : ' (coming soon)'}
          </option>
        ))}
      </select>
    </div>
  );
}
